import { jsx as _jsx } from "react/jsx-runtime";
import { PROMO_IMAGE_TITLE_SCALE, resolveBlockBackgroundPalette, resolveTypeScale } from "@diality/contracts";
import { ARComponent } from "../components/blocks/ar-component";
import { resolveSlotMedia } from "../render/slot-media";
export function arComponentFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    return {
        backgroundPalette: resolveBlockBackgroundPalette(s.backgroundPalette),
        title: s.title ?? "",
        titleSize: resolveTypeScale(PROMO_IMAGE_TITLE_SCALE, s.titleSize),
        desktop: resolveSlotMedia(block, "desktopImage", resolve),
        mobile: resolveSlotMedia(block, "mobileImage", resolve),
        label: s.label ?? "",
        vectaryUrl: s.vectaryUrl?.trim() ?? "",
        qrUrl: s.qrUrl?.trim() || undefined,
        dialogTitle: s.dialogTitle ?? "",
        dialogDescription: s.dialogDescription ?? "",
    };
}
export function ARComponentBlock({ data }) {
    // Incomplete drafts must not offer a link to the current page.
    if (!data.label.trim() || !data.vectaryUrl)
        return null;
    return _jsx(ARComponent, { title: data.title ?? "", label: data.label, vectaryUrl: data.vectaryUrl, qrUrl: data.qrUrl, dialogTitle: data.dialogTitle, dialogDescription: data.dialogDescription, titleSize: resolveTypeScale(PROMO_IMAGE_TITLE_SCALE, data.titleSize), imageSrc: data.desktop?.url ?? "", mobileImageSrc: data.mobile?.url, imageAlt: data.desktop?.alt ?? "" });
}
export const arComponentBlockEntry = {
    Component: ARComponentBlock,
    fromBlock: arComponentFromBlock,
};
//# sourceMappingURL=ar-component.js.map